import store from '@/store'

const crudAPI = {
  dfsResourceAll (resource) {
    let url = store.getters.config.api_host + '/api/' + resource

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  dfsResourceIndex (resource) {
    let url = store.getters.config.api_host + '/api/' + resource

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  dfsResourceShow (resource, itemId) {
    let url = store.getters.config.api_host + '/api/' + resource + '/' + itemId

    return new Promise((resolve, reject) => {
      store.getters.axios.get(url).then(response => {
        resolve(response.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  dfsResourceStore (resource, payload) {
    let url = store.getters.config.api_host + '/api/' + resource

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url, payload).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },

  dfsResourceDestroy (resource, itemId) {
    let url = store.getters.config.api_host + '/api/' + resource + '/' + itemId

    return new Promise((resolve, reject) => {
      store.getters.axios.delete(url).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },

  dfsResourceUpdate (resource, itemId, payload, additionalApiPath = '') {
    let url = store.getters.config.api_host + '/api/' + resource + '/' + itemId + additionalApiPath

    return new Promise((resolve, reject) => {
      store.getters.axios.put(url, payload).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default crudAPI



// WEBPACK FOOTER //
// ./src/api/resources/crud.js